import type {ReactElement} from 'react';
import React from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {useAppSelector} from '@/hooks';
import {getCurrentPageItems} from '@Components/poster-editor/poster-editor-reducer';
import {DefaultAnimationOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/default-animation-option/default-animation-option';
import {AnimationType} from '@PosterWhiteboard/items/item/item.types';

export interface DefaultAnimationOptionProps {
  onAnimationTypeClick: () => void;
}

export function PageAnimationOption({...props}: DefaultAnimationOptionProps): ReactElement {
  const currentPageItems = useAppSelector(getCurrentPageItems);

  if (!currentPageItems) {
    throw new Error('Unable to show animation options since the current page is null');
  }

  const hasItems = Object.keys(currentPageItems.itemsHashMap).length > 0;

  return (
    <AnimatePresence initial={false}>
      {hasItems ? (
        <motion.div
          layout
          key="page-animation-option"
          initial={{height: 0, opacity: 0}}
          animate={{height: 'auto', opacity: 1}}
          exit={{height: 0, opacity: 0}}
          transition={{duration: 0.2}}
        >
          <DefaultAnimationOption
            key={'page-level-animation-option'}
            introAnimation={AnimationType.NONE}
            outroAnimation={AnimationType.NONE}
            onAnimationTypeClick={props.onAnimationTypeClick}
            showAnimateLabelOnly
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
